import React from "react";
import AlertModal from '../AlertModal';

const NotificationAlert = (props) => {

    const {
        isShow,
        notificationObj,
        processingSaveAssessment
    } = props;

    const Saving = () => (<><i className="fa fa-spinner fa-spin"/>&nbsp;&nbsp;{notificationObj?.textWhileProcessingConfirmBtn ? notificationObj?.textWhileProcessingConfirmBtn : 'Saving'}</>)

    return (
        <AlertModal
            show={isShow}
            type={notificationObj.notificationAlert}
            title={notificationObj.notificationTitle}
            confirmBtnText={processingSaveAssessment ? <Saving/> : notificationObj.notificationConfirmBtnText}
            cancelBtnText={notificationObj.notificationCancelBtnText}
            showConfirm={notificationObj.showNotificationConfirmBtn}
            showCancel={notificationObj.showNotificationCancelBtn}
            showCloseButton={false}
            onConfirm={notificationObj.onConfirmNotificationAlert}
            onCancel={notificationObj.onCancelNotificationAlert}
            onClose={notificationObj.onCancelNotificationAlert}
            closeOnClickOutside={notificationObj.closeNotificationOutsideClick}
            confirmBtnCssClass={notificationObj.notificationConfirmBtnCss}
            cancelBtnCssClass={notificationObj.notificationCancelBtnCss}
            disabled={processingSaveAssessment ? true : false}>
            {notificationObj.notificationAlertMessage}
        </AlertModal>
    );
}

export default NotificationAlert;